<template>
    <div class="teachingClassDialog">
        <el-dialog :title="myTitle" width="60%"  fullscreen :visible.sync="dialogVisible" :close-on-click-modal="false">
                <el-form :inline="true" :model='searchForm' ref="searchForm" class="demo-form-inline search-form">
                    <el-form-item label="课程"  >
                        <div style="display: flex;" v-if="!isCheck">
                            <el-select v-model="searchForm.courseId" filterable clearable  placeholder="请输入课程名称或编号" remote :remote-method="remoteCourse" style="width: 100%" >
                            <!-- <el-select v-model="courseIds" filterable clearable  placeholder="请输入课程名称或编号" remote :remote-method="remoteCourse" style="width: 100%" multiple > -->
                                <el-option v-for="item in courceList" :key="item.id" :label="item.name+'('+item.course_no+')'" :value="item.id">
                                </el-option>
                            </el-select>
                            <el-button type="text" @click="configCourse" style="display: inline-block;" >+</el-button>
                        </div>
                        <!-- 多选结果 -->
                        <div v-else>
                            <el-select v-model="courseIds" multiple placeholder="请选择" @remove-tag="loadTeachingClassList">
                                <el-option v-for="item in multipleSelection" :key="item.id" :label="item.name+'('+item.course_no+')'" :value="item.id"></el-option>
                            </el-select>
                            <el-button type="text" @click="configCourse" style="display: inline-block;" >+</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="学年学期"  >
                        <el-select v-model="searchForm.acadyearTerm" filterable placeholder="请选择">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option v-for="item in acadyearTermList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="查找">
                        <el-input v-model="searchForm.searchText" placeholder="请填写教学班名称"  @keyup.enter.native='loadTeachingClassList'></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" size ="mini" icon="search" @click='loadTeachingClassList'>查询</el-button>
                        <el-button type="info" size ="mini" icon="search" @click='checkAll'>全选</el-button>
                        <el-button type="info" size ="mini" icon="search" @click='checkAllByScan' style="background-color:#67c23a;color:#fff;border-color: #67c23a;">勾选扫描班级</el-button>
                        <el-button type="danger" size ="mini" icon="search" @click='checkCancel'>清空</el-button>
                        <!-- <el-button type="info" size ="mini" icon="search" @click='configCourse'>多选课程</el-button> -->
                    </el-form-item>
                </el-form>
            <el-table v-loading="loading" :data="tableData" height= 600 style="width: 100%;"   :row-style="tableRowStyle"  @row-click="handleRowClick"   align='center'>
                <el-table-column prop="name" label="名称"  width="150" align='center' ></el-table-column>
                <el-table-column prop="acadyear_term" label="学年学期" width="200" align='center' ></el-table-column>
                <el-table-column prop="cource_name" label="课程名称" align='center' ></el-table-column>
                <!-- <el-table-column prop="hard_class_count" label="行政班数" align='center' ></el-table-column> -->
                <el-table-column prop="teacher_name" label="创建老师" align='center' ></el-table-column>
              <el-table-column prop="student_count" label="学生人数" align='center' ></el-table-column>
              <el-table-column prop="scan_student_count" label="扫描人数" align='center' ></el-table-column>
              <el-table-column prop="scan_student_count" label="状态" align='center' >
                <template slot-scope="scope">
                    <el-tag type="success" v-if="selectList.some(item => item.id === scope.row.id)">已选中</el-tag>
                    <el-tag type="info" v-else>未选中</el-tag>
                </template>
              </el-table-column>
                <el-table-column prop="operation" align='center' label="操作" min-width="350">
                    <template slot-scope='scope'>
                        <el-button  icon='edit' size="mini" type="danger" v-if="selectList.some(item => item.id === scope.row.id)" @click="cancelChoose(scope.row)">取 消</el-button>
                        <el-button icon='edit' type="primary" size="mini" @click='selectTeaching(scope.row)' v-else>选 择</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination  :pageSize="searchForm.pageSize" :currentPage="searchForm.pageNo" :pageTotal="searchForm.totalCount" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>

            <div style="margin-top: 20px; text-align: left;">
                <h1>选中教学班列表：</h1>
                <div class="tags-container">  
                    <p v-for="(tag, index) in selectList" :key="tag.id" class="tag-item">  
                    {{ index+1 }}: {{ tag.name }}  
                    <i class="el-icon-circle-close" @click="removeItem(index)"></i>
                    </p>  
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="submitFormCheck">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="配置课程" width="45%" :visible.sync="dialogVisibleByCourse">
            <el-form :inline="true" :model='courseForm' ref="courseForm" class="demo-form-inline search-form">
                <el-form-item label="开课单位"  prop="schoolId" :label-width="formLabelWidth" clearable>
                    <el-select v-model="courseForm.schoolId" filterable placeholder="请选择">
                        <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-form-item label="课程名称"  >
                       <el-input v-model="courseForm.searchText" placeholder="请输入课程名称" clearable></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" size ="mini" icon="search" @click='loadCourceListByConfig'>查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="courceListConfig"  @selection-change="handleSelectionChange"  row-key="id" ref="multipleTable" @load="loadingCourse">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="70" label="序号"></el-table-column>
                <el-table-column prop="course_no" label="课程编号"   ></el-table-column>
                <el-table-column prop="name" label="课程名称" ></el-table-column>
            </el-table>
            <pagination  :pageSize="courseForm.pageSize" :currentPage="courseForm.pageNo" :pageTotal="courseForm.totalCount" @handleCurrentChange="handleCurrentChangeByCourse" @handleSizeChange="handleSizeChangeByCourse"></pagination>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelByCourse">取 消</el-button>
                <el-button type="primary" :loading="loading" @click="submitFormByCourse">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import * as simpleApi from "request/simple";
    import XEUtils from 'xe-utils'
    import * as mUtils from '@/utils/mUtils'
    import Pagination from "@/components/pagination";


    export default {
        name: 'teachingClassDialog',
        data(){
            return {
                formLabelWidth: '120px', myTitle: null,
                dialogVisible:false, 
                loading: false, 
                examId: null,  
                rules: null,
                tableData: [], 
                acadyearTermList: [], 
                selectList: [],
                searchForm: { 
                    pageNo: 1, 
                    pageSize: 50, 
                    totalCount: 0, 
                    searchText: null, 
                    licenceId: null, 
                    teacherId: null, 
                    schoolId: null, 
                    acadyearTerm: null, 
                    courseId: null
                },
                currentRow: null,
                courceList: [],
                // 多选课程列表
                courseIds:[],
                dialogVisibleByCourse: false,
                courceListConfig: [],
                courseForm:{
                    searchText: null,
                    pageNo: 1, 
                    pageSize: 50, 
                    totalCount: 0, 
                },
                loadingCourse: true,
                multipleSelection: [],
                // 判断是否多选，切换课程样式
                isCheck: false,
                // 考试的课程
                courseInfo: null,
                // 开课单位
                schoolList:[]



            }
        },
        components:{
            Pagination
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            })
        },
      	mounted() {
            this.loadTeachingClassList();
            this.loadAcadyearTermList();
            this.loadCourceList();
	    },
        props: {
            teachingClass: {
                type: Object
            }
        },
        watch: {
            teachingClass: {
                deep: true, immediate:true,
                handler(n, o){
                    console.log(n)
                    if(n){
                        this.examId = n.id;
                        this.myTitle = n.name + "(" +n.id+")";
                        this.searchForm.searchText = null;
                        let rules = n.rules;
                        if(rules != null) {
                            let myRules = JSON.parse(rules);
                            this.rules = myRules;
                            if("teachingClassList" in myRules)
                                this.selectList = myRules.teachingClassList;
                            else
                                this.selectList = [];
                        }
                    }else{
                        this.selectList = [];
                        this.rules = null;
                    }
                }
            },
            courseIds:{
                deep: true, immediate:true,
                handler(n, o){
                    // 如果被选中的课程列表被清空后，切换为单选课程格式
                    if(this.courseIds.length == 0) this.isCheck = false
                }
            }
        },
        methods: {
            loadTeachingClassList(){
                this.loading = true;
                let search = { 
                    searchText: mUtils.searchText(this.searchForm.searchText), 
                    licenceId: this.userInfo.licenceId,
                    // teacherId: this.userInfo.id,
                    examId: this.examId,
                    schoolId: mUtils.searchText(this.searchForm.schoolId), 
                    // courseId: mUtils.searchText(this.searchForm.courseId),
                    acadyearTerm: mUtils.searchText(this.searchForm.acadyearTerm)
                };
                // debugger
                if(this.courseIds.length > 0){
                    // let ids = this.courseIds.join(",")
                    search.courseIds = this.courseIds
                    search.courseId = null
                }else{
                    search.courseId = mUtils.searchText(this.searchForm.courseId)
                }
                    
                let param = { controllerName: 'examTeachingClass', methodName: '/list', pageNo: this.searchForm.pageNo, pageSize: this.searchForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code === 0) {
                        this.tableData = data.result;
                        this.searchForm.pageNo = data.pageNo;
                        this.searchForm.pageSize = data.pageSize;
                        this.searchForm.totalCount = data.totalCount;
                    }
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    console.log("error")
                });
            },
            loadAcadyearTermList(){
                this.acadyearTermList = [];
                let now = new Date();
                let year = parseInt(now.getFullYear());
                for(let i=(year-3); i<(year+2); i++){
                    this.acadyearTermList.unshift((i-1) + '-' + i + '第一学期');
                    this.acadyearTermList.unshift((i-1) + '-' + i + '第二学期');
                }
            },
            // 获取当前的学年学期
            getCurrentAcademicTerm() {
                let now = new Date();
                let currentYear = now.getFullYear();
                let currentMonth = now.getMonth() + 1; // 月份从1开始
                
                let academicYear = null
                let term = null
                
                if (currentMonth >= 2 && currentMonth <= 7) {
                    // 2-7月：春季学期（第二学期），属于上一学年
                    term = '第二学期';
                    academicYear = `${currentYear - 1}-${currentYear}`;
                } else if (currentMonth >= 9 && currentMonth <= 12) {
                    // 9-12月：秋季学期（第一学期），属于当前学年
                    term = '第一学期';
                    academicYear = `${currentYear}-${currentYear + 1}`;
                } else {
                    // 1月或8月：特殊处理
                    if (currentMonth === 1) {
                        // 1月：还是上一学年的第一学期
                        term = '第一学期';
                        academicYear = `${currentYear - 1}-${currentYear}`;
                    } else { // currentMonth === 8
                        // 8月：暑假期间，返回空或特殊标记
                        term = '暑假';
                        academicYear = `${currentYear}-${currentYear + 1}`;
                    }
                }
                
                return `${academicYear}${term}`
            },

            showDialog(row){
                // 判断是否配置了多课程
                if("course_ids" in row && row.course_ids != null){
                    this.isCheck = true
                    this.loadCourseListByList(row.course_ids)
                    // this.multipleSelection = []
                }
                this.searchForm.courseId = row.course_id
                // 批量显示
                // let list = this.courceList.filter(item => item.id == row.course_id)
                // this.courseIds = []
                // this.courseIds = list.map(item => item.id)
                
                let acadyearTerm = mUtils.getSemesterWithHolidays()
                this.searchForm.acadyearTerm = acadyearTerm
                this.searchForm.examId = row.id
                this.getCourseId()
                // 弹窗显示
                this.loadTeachingClassList()
                this.dialogVisible = true;
            },
            hideDialog(){
                this.dialogVisible = false;
            },
            cancel(){
                this.selectList = []
                this.dialogVisible = false;
                this.$emit('cancel');
            },
            handleClose(index){
                this.selectList.splice(index, 1);
            },
            selectTeaching(row){
                // const type = this.selectList.some(item => item.id === row.id); // 查找行是否已被选中  
                // 新增选择  
                this.selectList.push({id: row.id, name: row.name, })
            },
            cancelChoose(row){
                let index = this.selectList.findIndex(item => item.id === row.id);  
                this.selectList.splice(index, 1);
            },
            // 上下分页
            handleCurrentChange(val){
                this.searchForm.pageNo = val;
                this.loadTeachingClassList()
            },
            // 每页显示多少条
            handleSizeChange(val){
                this.searchForm.pageSize = val;
                this.loadTeachingClassList()
            },
            // 课程分页
             // 上下分页
             handleCurrentChangeByCourse(val){
                this.courseForm.pageNo = val;
                this.loadCourceList()
            },
            // 每页显示多少条
            handleSizeChangeByCourse(val){
                this.courseForm.pageSize = val;
                this.loadCourceList()
            },
            submitFormCheck(){
                // if( this.selectList.length === 0) {
                //     this.$message.error("请选择教学班 ！")
                //     return
                // }

                let classIds = this.selectList.map(item=> item.id).join(',')
                // 校验勾选的教学班是否有遗漏的学生
                let params = {
                    examId: this.examId,
                    classIds: classIds
                }
                let param = { controllerName: 'examTeachingClass', methodName: '/checkTeachingClassByStudent', param: params};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {

                    // 如果存在未被勾选进的学生 则弹窗提示但是允许正常保存
                    if(data.length > 0){
                        // 去重并拼接
                        let names = [...new Set(data.map(item => item.student_name))].join(',')
                        let title = "考试号" + this.examId + "- " +names + " 未被包含在已被选中的教学班内，请老师检查教学班学生信息是否有遗漏！"
                        this.$message.error({message:title, duration: 0,  showClose: true })
                    }
                    this.submitForm()

                })
            },
            submitForm(){
                // 判断是否是多选状态
                debugger
                let that = this;
                if(this.rules == null) this.rules = {teachingClassList: null};
                this.rules["teachingClassList"] = this.selectList;
                let param = { controllerName: 'akExam', methodName: '/update', param: {id: this.examId, rules: JSON.stringify(this.rules)}};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    console.log('teachingClass', code);
                    if (code == 0) {
                        this.$message.success("设置教学班成功！")
                        this.dialogVisible = false;
                        that.$emit('ok');
                    }
                });
                this.saveCourseIds()
                // if(this.isCheck && this.courseIds.length > 0) 

            },
            // 动态绑定行样式
            tableRowStyle({ row }) {
                return this.selectList.some(item => item.id === row.id)
                    ? { backgroundColor: '#f0f7ff', cursor: 'pointer' }
                    : { cursor: 'pointer' };
            },
            loadCourceList(){
                // 判断登录用户是否是校级管理员
                let search = { licenceId: this.userInfo.licenceId};
                if(this.userInfo.role == "sclAdmin") search['schoolId'] = this.userInfo.schoolId
                let param = { controllerName: 'sclCource', methodName: '/list', pageNo: this.courseForm.pageNo, pageSize: this.courseForm.pageSize, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (data.code == 0) {
                        this.courceList = data.result;
                        this.courseForm.pageNo = data.pageNo;
                        this.courseForm.pageSize = data.pageSize;
                        this.courseForm.totalCount = data.totalCount;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            // 获取对应多选课程的信息 并返回给多选框 
            loadCourseListByList(value){
                let ids = value.split(',')
                let search = { licenceId: this.userInfo.licenceId,ids: ids}
                let param = { controllerName: 'sclCource', methodName: '/listAll', param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    this.courseIds = data.map(item => item.id)
                    this.multipleSelection = data
                })
            },
            // 提前获取指定courseId 的信息
            getCourseId(){
                let id = this.searchForm.courseId
                let search = { id: id}
                let param = { controllerName: 'sclCource', methodName: '/select',param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if(data != null) {
                        this.courseInfo = data
                        data.course_no = data.courseNo
                        // 判断课程是否已存在
                        let filter = this.courceList.filter(item => item.id == data.id)
                        if(filter.length == 0) this.courceList.push(data)
                        
                    }

                }).catch((error) => {
                    console.log("error")
                });
            },
            // 全选全部教学班
            checkAll(){
                // 判断选择栏目是否全选
                // this.selectList = this.tableData
                if(this.selectList.length == 0){
                    this.selectList = JSON.parse(JSON.stringify(this.tableData));
                }else{
                    // 过滤后把不在选择列表里边的数据插入
                    let selectList = this.selectList.map(item => item.id);
                    let tableNoIN = this.tableData.filter(item => !selectList.includes(item.id));

                    // 将不重复的数据插入到 selectList
                    tableNoIN.forEach(item => {
                        this.selectList.push(item);
                    });

                }
                
            },
            checkCancel(){
                this.selectList = []
                
            },
            // 仅勾选有扫描数据的班级
            checkAllByScan(){
                let filter = this.tableData.filter(item => 'scan_student_count' in item && item.scan_student_count > 0)
                // 只能选择当页的数据
                if(this.selectList.length == 0){
                    this.selectList = JSON.parse(JSON.stringify(filter));
                }else{
                    // 过滤后把不在选择列表里边的数据插入
                    let selectList = this.selectList.map(item => item.id);
                    let tableNoIN = filter.filter(item => !selectList.includes(item.id));

                    // 将不重复的数据插入到selectList
                    tableNoIN.forEach(item => {
                        this.selectList.push(item);
                    });
                }
                
                let title = '当前课程和学期有扫描人数的班级已全部选中,共 ' + filter.length + ' 条'
                this.$message.info(title)
            },
            // 多选课程
            configCourse(){
                if(this.userInfo.role == "sclAdmin") this.courseForm.schoolId = this.userInfo.schoolId
                this.courseForm.licenceId = this.userInfo.licenceId
                this.courseForm.schoolId = this.courseInfo.schoolId
                this.loadCourceListByConfig()
                this.loadSchoolList()
                this.dialogVisibleByCourse = true
                
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 配置课程取消时，重新读取courseList列表的值
            cancelByCourse(){
                this.courseForm.pageNo = 1;
                this.courseForm.pageSize = 50;
                // this.loadCourceList()
                this.dialogVisibleByCourse = false
            },
            submitFormByCourse(){
                 // 判断是否有勾选课程 勾选的课程保存
                 if(this.multipleSelection.length > 0){
                    this.isCheck = true
                    this.courseIds = []
                    this.courseIds = this.multipleSelection.map(item => item.id)
                }else{
                    this.isCheck = false
                }
                this.loadTeachingClassList()
                this.dialogVisibleByCourse = false
            },
            loadCourceListByConfig(){
                this.loadingCourse = true
                if(this.courseForm.searchText == '') this.courseForm.searchText = null
                let param = { controllerName: 'sclCource', methodName: '/list', pageNo: this.courseForm.pageNo, pageSize: this.courseForm.pageSize, param: this.courseForm};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (data.code == 0) {
                        this.courceListConfig = data.result;
                        this.courseForm.pageNo = data.pageNo;
                        this.courseForm.pageSize = data.pageSize;
                        this.courseForm.totalCount = data.totalCount;
                    }
                    this.loadingCourse = false
                }).catch((error) => {
                    console.log("error")
                    this.loadingCourse = false
                });
            },
            // 更新课程
            saveCourseIds(){
                let courseIds = this.courseIds.join(',')
                let search = {
                    id: this.examId,
                    courseIds: courseIds
                }
                let param = { controllerName: 'akExam', methodName: '/updateByCourseIds', param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {})
            },
            // 开课单位
            loadSchoolList(){
                let search = { licenceId: this.userInfo.licenceId};
                let param = { controllerName: 'school', methodName: '/list', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    if (data.code == 0) {
                        this.schoolList = data.result;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            // 列表删除
            removeItem(index) {
                this.selectList.splice(index, 1);
            }
            
        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

.tags-container {  
  display: flex;              /* 使用 Flexbox 布局 */  
  flex-wrap: wrap;           /* 允许换行 */  
//   justify-content: center;    /* 居中对齐项 */  
  justify-content: flex-start;  /* 靠左排列 */  
  margin: 10px 0;            /* 添加顶部和底部间距 */  
}  

.tag-item {  
//   flex: 0 0 calc(25% - 10px); /* 4个一列 每个 <h3> 占 25% 宽度并留出间距 */  
  flex: 0 0 calc(16.67% - 10px); 
  margin: 5px;                /* 标签之间的间距 */  
  text-align: center;         /* 标签文本居中 */  
} 

.tag-item .el-icon-circle-close {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.tag-item:hover .el-icon-circle-close {
  opacity: 1;
}


</style>


